namespace GeniuzPOS.InventoryReport {
    export class IcReport05AllColumns {
        static columnsKey = 'InventoryReport.IcReport05All';
    }
}
